import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { ShieldCheck, Loader2, ArrowLeft } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      navigate("/admin");
    } catch (ex) {
      setErr(formatApiErrorDetail(ex.response?.data?.detail) || ex.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background grain flex items-center justify-center px-6" data-testid="admin-login">
      <div className="w-full max-w-md fade-up">
        <div className="flex items-center justify-center mb-8">
          <img src="/logo-colored.png" alt="Centro Auto Pontedera" className="h-24 w-auto" />
        </div>
        <div className="rounded-2xl border border-white/10 bg-[#181A22] p-8">
          <div className="flex items-center gap-2 mb-6"><ShieldCheck className="w-5 h-5 amber" /><h1 className="font-display text-xl font-bold uppercase">Area Amministratore</h1></div>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="bg-[#12141A] border-white/10 mt-1.5" data-testid="login-email" required /></div>
            <div><Label>Password</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="bg-[#12141A] border-white/10 mt-1.5" data-testid="login-password" required /></div>
            {err && <p className="text-sm text-[#E63946]" data-testid="login-error">{err}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-[#E63946] hover:bg-[#D62828] text-white rounded-full h-11 font-semibold" data-testid="login-submit">
              {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Accedi"}
            </Button>
          </form>
        </div>
        <Link to="/" className="mt-6 flex items-center justify-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors" data-testid="login-back-to-site">
          <ArrowLeft className="w-4 h-4" /> Torna al sito
        </Link>
      </div>
    </div>
  );
}
